var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRailgun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M109.717 38.226L108.975 39.015L96.4001 42.0645",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M118.708 21.342L118.235 19.923L118.402 17.865C118.402 17.865 117.512 17.448 117.317 16.335C117.122 15.222 114.536 15.3615 114.536 15.3615C114.536 15.3615 107.693 15.3435 106.297 15.3435C104.9 15.3435 103.828 16.2525 103.828 16.2525L102.77 17.31H93.9805L91.756 16.086H84.0235L79.072 11.19C76.2355 10.8555 63.1345 12.636 63.1345 12.636H57.4885V13.6935H51.619L50.5345 13.1925C50.5345 13.1925 8.31249 13.1745 5.72499 13.1835C3.13749 13.1925 2.69349 14.361 2.69349 14.361V18.3105L1.80399 18.5325V22.482H9.06249L10.537 22.0785H59.9635L61.591 21.87L65.9725 21.675L67.279 22.0575L67.141 22.9125H62.0095L61.258 23.622L62.218 24.7485H43.1935L35.962 25.791H16.531L14.821 24.7485H2.97099L1.80249 25.416V26.751L2.63649 27.021L3.21999 27.774V28.851L2.63649 31.341L4.30599 31.551L5.80749 33.357H52.6765L53.038 32.661H54.373L55.486 32.9955H56.3755L56.7655 31.8555H58.7125L60.256 32.3565L61.633 32.3115L62.5225 32.802H72.3415C72.3415 32.802 73.2595 32.5245 74.2885 32.3295C75.3175 32.1345 75.346 33.5805 76.057 34.0665C76.768 34.5525 77.734 34.272 79.462 34.269C81.19 34.266 82.279 35.445 82.279 35.445C82.279 35.445 84.2185 38.8695 84.7225 40.368C85.225 41.8665 84.4135 42.315 84.4135 42.315L85.0255 43.9845C85.0255 43.9845 85.777 44.301 86.9245 44.334C88.072 44.367 88.753 43.944 88.753 43.944L89.6155 43.2885L95.4865 41.694L96.4015 42.0645L108.976 39.0165L109.718 38.226L111.028 38.121C111.028 38.121 113.228 37.524 115.634 36.756C118.04 35.988 117.584 33.804 117.584 33.804L117.179 27.9615L117.847 27.183L117.919 25.3335L118.319 23.5395L118.123 22.8615L118.709 21.342H118.708ZM80.2405 32.718C80.2405 32.718 79.7605 33.0315 78.8425 33.0315C77.9245 33.0315 76.1725 33.0105 76.0885 32.259C76.0045 31.5075 76.1095 29.6625 76.1095 29.6625H79.1965C79.1965 29.6625 79.321 30.153 79.1965 30.6945C79.072 31.2375 78.3205 31.779 78.3205 31.779C78.3205 31.779 79.7815 32.0715 80.239 30.945V32.718H80.2405ZM94.759 34.368C94.759 35.577 93.7795 36.5565 92.5705 36.5565H91.8265C90.523 36.5565 89.3335 35.8155 88.759 34.6455L87.454 31.9875C87.0775 31.221 87.6355 30.327 88.489 30.327H92.7205C93.847 30.327 94.7605 31.2405 94.7605 32.367V34.3695L94.759 34.368Z",
    fill: "#FAFAFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.488 13.6934H62.828L67.556 18.3659H71.006",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8203 19.9784V16.6409H54.0378",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9726 16.6409H42.4671V15.3614H37.3101V16.0844H4.64012L3.02612 17.6984",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7097 18.8669H45.9722",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.286 22.9829H112.937V28.8524",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.838 26.8769H115.286",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.059 18.9224H115.286",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.173 15.3614C113.173 15.3614 113.563 16.8629 111.503 16.8629H103.66",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8066 22.9829H90.9191C90.5261 22.9829 90.1451 22.8434 89.8436 22.5899L87.0281 20.2169C86.8196 20.0414 86.9441 19.6994 87.2171 19.6994H96.8051C97.0571 19.6994 97.2625 19.9034 97.2625 20.1569V22.5254C97.2625 22.7774 97.0586 22.9829 96.8051 22.9829H96.8066Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7126 16.6409H78.1071C77.6916 16.6409 77.2926 16.4759 76.9986 16.1819L73.8966 13.0799C73.7421 12.9254 73.8381 12.6614 74.0556 12.6419L76.5951 12.4139C77.0016 12.3779 77.4021 12.5234 77.6901 12.8114L80.9496 16.0709C81.1596 16.2809 81.0111 16.6409 80.7141 16.6409H80.7126Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3396 13.4144V16.5599C71.3396 16.7279 71.4761 16.8644 71.6441 16.8644H74.5406C74.8061 16.8644 74.9441 16.5494 74.7641 16.3544L71.8676 13.2089C71.6801 13.0049 71.3396 13.1384 71.3396 13.4144Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6145 13.4579V16.1609C69.6145 16.4354 69.292 16.5809 69.0865 16.4009L66.5035 14.1359C66.301 13.9589 66.3955 13.6274 66.661 13.5824L69.244 13.1459C69.439 13.1129 69.616 13.2629 69.616 13.4594L69.6145 13.4579Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3637 19.9799L87.5782 22.6139C87.7297 22.7384 87.6412 22.9829 87.4462 22.9829H84.2317C84.1162 22.9829 84.0232 22.8899 84.0232 22.7744V20.1404C84.0232 19.9649 84.2272 19.8674 84.3637 19.9799V19.9799Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2124 16.1129L92.3809 17.7824H86.4138L85.1208 16.1129",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.66 29.6624H108.152V33.4409L103.66 29.6624Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.271 30.9659V34.6799H107.026V33.9284L103.271 30.9659Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M118.082 19.0964H117.373C117.373 19.0964 116.726 19.2014 116.726 19.8689C116.726 20.5364 117.404 20.7029 117.404 20.7029H118.457",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M118.082 22.0589H117.373C117.373 22.0589 116.726 22.1639 116.726 22.8314C116.726 23.4989 117.404 23.6654 117.404 23.6654H118.457",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.255 36.5563V38.3083C91.255 38.3083 91.2265 39.1708 91.7005 39.2818C92.1745 39.3928 92.0695 39.8098 92.0935 40.3393C92.1175 40.8688 92.0935 42.6148 92.0935 42.6148",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2283 22.0589L76.0563 18.8669H79.1823L81.0468 20.7029",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2937 26.8769L60.2552 26.3339H68.7242V29.6609H61.9937C61.9937 29.6609 61.0757 29.6849 61.0757 30.1994C61.0757 30.7139 61.7852 30.7274 61.9517 30.7274H68.7242V32.8559",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0037 32.8019V30.5279L70.9142 29.7719H74.3777V32.3264",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7244 28.191H111.026",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5515 24.8475H70.5325V26.127H81.547V28.191",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6998 27.2175H69.7263V28.191H70.6998V27.2175Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4352 27.2174H79.4617V28.1909H80.4352V27.2174Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M98.66 30.6524H100.496C100.496 30.6524 101.65 30.6539 101.894 31.2149C102.103 31.6949 101.836 32.1404 100.789 32.7164C99.4745 33.4394 98.006 33.5744 97.5005 32.5874C97.118 31.8404 97.3415 30.7979 98.6615 30.6524H98.66Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M107.442 19.9785H105.147V21.342H107.442V19.9785Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80228 22.2886V18.5341L2.69178 18.3121V14.3626C2.69178 14.3626 2.80278 13.2496 4.86078 13.1941C6.91878 13.1386 50.5328 13.1941 50.5328 13.1941L51.1448 13.6951H57.4868V12.6376H63.4943C63.4943 12.6376 67.8338 11.4136 79.0703 11.1916L84.0218 16.0876H91.7543L93.9788 17.3116H102.769L103.826 16.2541C103.826 16.2541 103.771 15.3451 107.053 15.3451H115.286C115.286 15.3451 116.399 15.4201 117.317 16.3381C117.317 16.3381 116.983 17.0611 117.512 17.4511C118.042 17.8411 118.402 17.8681 118.402 17.8681L118.567 19.1191C118.567 19.1191 118.18 19.4536 118.235 19.9261C118.291 20.3986 118.708 20.7331 118.708 20.7331V21.9571C118.708 21.9571 118.069 22.3741 118.124 22.9021C118.18 23.4301 118.319 23.5411 118.319 23.5411L117.791 25.9051C117.791 25.9051 118.042 26.5726 117.847 27.1846C117.652 27.7966 117.179 27.9631 117.179 27.9631C117.179 27.9631 117.583 31.2181 117.583 32.7616C117.583 34.3051 117.749 35.8906 116.039 36.6001C114.329 37.3096 110.615 38.2276 110.615 38.2276L110.51 37.8316L109.718 38.2276L109.739 38.8321L96.4028 42.0661L95.7638 41.6206L89.6168 43.2901L88.9778 43.8736C88.9778 43.8736 87.2813 44.4571 86.1413 44.3461C85.0013 44.2351 85.0283 43.9846 85.0283 43.9846L84.4163 42.3151C84.4163 42.3151 85.1123 41.4256 84.5828 39.8116C84.0548 38.1991 82.4408 35.1391 81.4403 34.6666C80.4383 34.1941 80.0768 34.2496 79.2713 34.2766C78.4643 34.3051 76.8518 34.2481 76.8518 34.2481C76.8518 34.2481 75.6278 34.1086 75.3503 33.5806C75.0728 33.0526 74.9603 32.2726 74.2928 32.3296C73.6253 32.3851 73.2638 32.5246 73.2638 32.5246L72.3458 32.8021H62.5268L62.0813 32.3566H60.2588L59.2973 31.8556H56.7683L56.6843 32.5516L56.3783 32.9971H55.4888L55.2668 32.6626H53.0423L52.6808 33.3586H5.80878L4.80678 31.5931L3.80478 31.6351L2.63628 31.3426L3.55428 28.2556L3.21978 27.7756V27.2116L1.80078 26.7526V25.4176C1.80078 25.4176 1.84278 24.7501 2.96928 24.7501H14.8208L16.5308 25.7926H36.0143L43.1903 24.7501H63.4253V24.2911H61.8818C61.8818 24.2911 61.2563 24.0406 61.2563 23.6236C61.2563 23.2066 62.0078 22.9141 62.0078 22.9141H67.8068V22.2046L66.5963 21.8701H61.5893L60.6713 22.0786H10.5368L9.53478 22.4821H1.80228V22.2871V22.2886Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80493 31.6336L4.30593 30.2566H6.93393C6.93393 30.2566 7.35093 29.3386 8.35293 29.3386C9.35493 29.3386 9.64593 30.2146 9.64593 30.2146H13.1499L16.3629 33.3571",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22168 27.2115C3.22168 27.2115 3.63868 26.3355 4.68268 26.3355H8.47918V26.961H12.5262L14.0277 27.774H30.7587L31.4262 28.254H35.9322L45.9867 26.793V26.334H57.7947L60.2562 28.4205V29.7705H54.1227C54.1227 29.7705 52.8297 29.6295 52.8297 30.5055V32.988",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 25.7926V24.8746H17.6571L18.2961 25.7926",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9658 25.7926V24.8746H20.8553L21.4958 25.7926",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1641 25.7926V24.8746H24.0551L24.6941 25.7926",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3633 25.7926V24.8746H27.2528L27.8933 25.7926",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5613 25.7926V24.8746H30.4523L31.0913 25.7926",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7607 25.7926V24.8746H33.6502L34.2907 25.7926",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.959 25.7926V24.8746H36.85L37.3105 25.5361",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08105 20.6477L2.80405 20.2022H6.03055L7.25455 18.8672H15.7101L17.0451 20.3132H63.05L63.9411 19.3112H70.0596L70.5051 18.5327H77.1245L78.182 17.8097H81.353L84.023 16.0847",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3529 17.8096V22.1491H70.0039L71.1724 24.0406H89.3074L92.5339 27.0436H105.273V26.0986L107.609 23.7616H111.003L111.837 24.3181V27.0436L109.556 30.2701V33.7201L110.391 34.8886V37.8301",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M115.286 15.3436V16.6411H114.284C114.284 16.6411 113.672 16.7521 113.672 17.3641C113.672 17.9761 114.229 18.1156 114.229 18.1156H115.286V29.2966H114.479L114.089 28.8511H112.198V29.7706L111.253 30.1591C111.253 30.1591 110.669 30.4936 110.614 30.9106C110.558 31.3276 110.614 31.5496 110.614 31.5496C110.614 31.5496 110.558 31.9396 111.421 31.9111L112.283 31.8826L112.939 32.2996L114.148 32.1601L115.288 32.7436V36.8791",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5703 18.5056V24.8476H104.494L107.165 22.4551H111.059V18.5056H98.5703Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3729 16.6411H45.9729V18.9226H54.3729V16.6411Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5721 36.5566H91.8281C90.5246 36.5566 89.3351 35.8156 88.7606 34.6456L87.4556 31.9876C87.0791 31.2211 87.6371 30.3271 88.4906 30.3271H92.7221C93.8486 30.3271 94.7621 31.2406 94.7621 32.3671V34.3696C94.7621 35.5786 93.7826 36.5581 92.5736 36.5581L92.5721 36.5566Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1088 29.6625H79.1958C79.1958 29.6625 79.3203 30.153 79.1958 30.6945C79.0713 31.236 78.3198 31.779 78.3198 31.779C78.3198 31.779 79.7808 32.0715 80.2383 30.945V32.718C80.2383 32.718 79.7583 33.0315 78.8403 33.0315C77.9223 33.0315 76.1703 33.0105 76.0863 32.259C76.0023 31.5075 76.1073 29.6625 76.1073 29.6625H76.1088Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailgun);
export default __webpack_public_path__ + "static/media/Railgun.5a6f33def85e17414abfe94a4be884ea.svg";
export { ForwardRef as ReactComponent };